module.exports = __webpack_public_path__ + "static/img/yd-banner.1d12160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-banner.png
// module id = 7JSO
// module chunks = 1